module.exports = __webpack_public_path__ + "5216fc63ce1fce31043d57573f29245c.png";